export const layouts = {
  globalSearch: {
    placeholder: "Explore over 60,000 comics",
  },
  errorScreen: {
    somethingWentWrong: "Something went wrong",
  },
};
